// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3BZMq","emails":"CreateEditClinics_emails__3Kx5v","emailTagLabel":"CreateEditClinics_emailTagLabel__qK8mT"};